import FireInsureRules from './FireInsureRules';
export default FireInsureRules;
